import { scopeStacks } from './scopeStacks';
export function getCurrentABC() {
    if (scopeStacks.length === 0) {
        return null;
    }
    var globalObject = scopeStacks[scopeStacks.length - 1].topScope().global.object;
    return globalObject.globalInfo.abc;
}
